import { render, staticRenderFns } from "./Tadawul.vue?vue&type=template&id=3ca1687e&"
import script from "./Tadawul.vue?vue&type=script&lang=js&"
export * from "./Tadawul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports